/* This component is auto-generated with figma-svg. */
export enum ServiceView {
    Label = 'Label',
    EmployersRating = 'EmployersRating',
    Checkmark = 'Checkmark',
    DreamJob = 'DreamJob',
    CompanysLife = 'CompanysLife',
    HrBrand = 'HrBrand',
    Index = 'Index',
    Talantix = 'Talantix',
    ItAccreditation = 'ItAccreditation',
}

export interface ServiceLabel {
    kind: ServiceKind.Thumb | ServiceKind.Eye | ServiceKind.Flame | ServiceKind.User;
    view: ServiceView.Label;
}
export interface ServiceEmployersRating {
    scale: ServiceScale.Medium | ServiceScale.Small;
    kind: ServiceKind.Color | ServiceKind.Default;
    view: ServiceView.EmployersRating;
}
export interface ServiceCheckmark {
    scale: ServiceScale.Small | ServiceScale.Medium;
    view: ServiceView.Checkmark;
}
export interface ServiceDreamJob {
    scale: ServiceScale.Medium | ServiceScale.Small;
    view: ServiceView.DreamJob;
}
export interface ServiceCompanysLife {
    scale: ServiceScale.Small | ServiceScale.Medium;
    kind: ServiceKind.Default | ServiceKind.Color;
    view: ServiceView.CompanysLife;
}
export interface ServiceHrBrand {
    scale: ServiceScale.Medium | ServiceScale.Small;
    kind: ServiceKind.Default | ServiceKind.Color;
    view: ServiceView.HrBrand;
}
export interface ServiceIndex {
    scale: ServiceScale.Medium | ServiceScale.Small;
    view: ServiceView.Index;
}
export interface ServiceTalantix {
    scale: ServiceScale.Small | ServiceScale.Medium;
    view: ServiceView.Talantix;
}
export interface ServiceItAccreditation {
    scale: ServiceScale.Small | ServiceScale.Medium;
    view: ServiceView.ItAccreditation;
}

export type ServiceInvariants =
    | ServiceLabel
    | ServiceEmployersRating
    | ServiceCheckmark
    | ServiceDreamJob
    | ServiceCompanysLife
    | ServiceHrBrand
    | ServiceIndex
    | ServiceTalantix
    | ServiceItAccreditation;

export enum ServiceKind {
    Thumb = 'Thumb',
    Color = 'Color',
    Default = 'Default',
    Eye = 'Eye',
    Flame = 'Flame',
    User = 'User',
}
export enum ServiceScale {
    Medium = 'Medium',
    Small = 'Small',
}
